"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import Link from "next/link";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import BrainLeftSidebarWaves from "../left-sidebar/waves/BrainLeftSidebarWaves";
import MemesWaveFooter from "../left-sidebar/waves/MemesWaveFooter";
import { useLayout } from "../my-stream/layout/LayoutContext";
interface BrainMobileWavesProps {
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
}
const BrainMobileWaves: React.FC<BrainMobileWavesProps> = t0 => {
  const $ = _c(8);
  const {
    onOpenQuickVote,
    onPrefetchQuickVote
  } = t0;
  const {
    mobileWavesViewStyle
  } = useLayout();
  const scrollContainerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-flex tw-size-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-900 tw-text-primary-300 tw-ring-1 tw-ring-inset tw-ring-iron-700 desktop-hover:group-hover:tw-bg-iron-800"><Squares2X2Icon className="tw-size-5" aria-hidden="true" /></span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-space-y-4 tw-px-2 sm:tw-px-4 md:tw-px-6 tw-pt-2" ref={scrollContainerRef}><Link href="/waves?view=profile-feed" prefetch={false} className="tw-group tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-px-4 tw-py-3 tw-text-iron-200 tw-no-underline tw-ring-1 tw-ring-inset tw-ring-white/5 tw-transition desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-bg-iron-900 desktop-hover:hover:tw-text-white">{t1}<span className="tw-min-w-0"><span className="tw-block tw-text-sm tw-font-semibold">Profile Waves Feed</span><span className="tw-mt-0.5 tw-block tw-text-xs tw-leading-5 tw-text-iron-400">Featured drops from profile waves</span></span></Link><BrainLeftSidebarWaves scrollContainerRef={scrollContainerRef} /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onOpenQuickVote || $[3] !== onPrefetchQuickVote) {
    t3 = <MemesWaveFooter onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} />;
    $[2] = onOpenQuickVote;
    $[3] = onPrefetchQuickVote;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== mobileWavesViewStyle || $[6] !== t3) {
    t4 = <div className="tw-flex tw-h-full tw-min-h-0 tw-flex-col" style={mobileWavesViewStyle}>{t2}{t3}</div>;
    $[5] = mobileWavesViewStyle;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default BrainMobileWaves;